/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { Outlet, useNavigate } from 'react-router-dom';
import Footer from '../Footer';
import Sidebar from './Sidebar';
import Header from '../Header';
import HeaderContext from '../Context/HeaderContext';
import ThreeDotsLoader from '../LoadingDots';

const unsavedChangesModalStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};

export default function Layout({ children }) {
    const [isPopup, setisPopup] = useState(false);
    const [ErrorMessage, SetErrorMessage] = useState('');
    const [SuccessMessage, SetSuccessMessage] = useState('');
    const [colorValue, setcolorValue] = useState(false);
    const [HardRefresh, setHardRefresh] = useState(false);
    const [collapsed, setcollapsed] = useState(false);
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const [saveHandler, setSaveHandler] = useState(null);
    const [pendingUrl, setPendingUrl] = useState(null);
    const [savingBeforeLeave, setSavingBeforeLeave] = useState(false);
    const navigate = useNavigate();
    useEffect(() => {
        setcollapsed(Boolean(localStorage.getItem('collapse') != 'false'));
    }, []);
    const requestNavigation = (url) => {
        if (hasUnsavedChanges) {
            setPendingUrl(url);
        } else {
            navigate(url);
        }
    };
    const discardAndLeave = () => {
        setHasUnsavedChanges(false);
        setPendingUrl(null);
        navigate(pendingUrl);
    };
    const saveAndLeave = async () => {
        if (!saveHandler) {
            discardAndLeave();
            return;
        }
        setSavingBeforeLeave(true);
        const success = await saveHandler();
        setSavingBeforeLeave(false);
        if (success) {
            setHasUnsavedChanges(false);
            setPendingUrl(null);
            navigate(pendingUrl);
        }
    };
    const closeUnsavedChangesPopup = () => setPendingUrl(null);

    return (
        <div>
            <HeaderContext.Provider value={{
                isPopup,
                setisPopup,
                ErrorMessage,
                SetErrorMessage,
                SuccessMessage,
                SetSuccessMessage,
                colorValue,
                setcolorValue,
                HardRefresh,
                setHardRefresh,
                collapsed,
                setcollapsed,
                hasUnsavedChanges,
                setHasUnsavedChanges,
                setSaveHandler,
                requestNavigation,
            }}
            >
                <Header {...children} />
                <div className="flex">
                    <Sidebar {...children} />
                    <div className={`px-[25px] pb-[25px] ml-[26%] w-[74%] main-screen ${collapsed ? 'show' : ''}`}>
                        <Outlet />

                        {children}
                    </div>
                </div>
                <Footer />
                <Modal
                    style={unsavedChangesModalStyles}
                    isOpen={pendingUrl !== null}
                    onRequestClose={closeUnsavedChangesPopup}
                >
                    <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none max-w-[441px]">
                        <div
                            className={'modal-content border-none shadow-lg relative flex flex-col w-full '
                                + 'pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current'}
                        >
                            <div className="modal-header flex flex-shrink-0 items-center justify-center p-4 rounded-t-md">
                                <h5 className="text-lg font-semibold text-[#090406] text-center w-full">
                                    Unsaved Changes
                                </h5>
                            </div>
                            <div className="modal-body relative px-9 pt-2 pb-6 text-center">
                                <p className="text-xs6 font-normal text-[#555259]">
                                    You have unsaved changes. Do you want to update?
                                </p>
                            </div>
                            <div className="modal-footer flex pb-6 rounded-b-md px-9">
                                <button
                                    onClick={discardAndLeave}
                                    type="button"
                                    disabled={savingBeforeLeave}
                                    className={'border border-[#555259] bg-[#ffffff] text-base font-normal '
                                        + 'text-[#555259] py-3 w-[168px] rounded-lg mr-[22px]'}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={saveAndLeave}
                                    type="button"
                                    disabled={savingBeforeLeave}
                                    className={'border border-[#673593] bg-[#555259] text-base font-normal '
                                        + 'text-[#ffffff] py-3 w-[168px] rounded-lg flex justify-center items-center'}
                                >
                                    {savingBeforeLeave ? <ThreeDotsLoader /> : 'Save'}
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
            </HeaderContext.Provider>

        </div>
    );
}
